import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Implemented Chris' double surface refraction...`}</p>
    <h1>{`Refraction`}</h1>
    <p>{`I would like to say, people’s (as least for people who did not see that before 🙂) eyes are really forgiving. I originally planned to do some research on RenderMonkey’s ToolSuite SDK to precompute normal distance Wyman `}{`[2005]`}{`. Now, without any precomputation, but crude and direct approximation. These pictures are only beautiful in pictures and too ugly in theory🙂. I think it could be used in game.`}</p>
    <p>{`Since there are no work worth mentioning, just show some pictures.`}</p>
    <h1>{`Single Refraction`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "339px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "94%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIEBQED/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAABqR9KYeC4I3cYx24Lr//EAB4QAAIBAwUAAAAAAAAAAAAAAAIDAQAQERITITNB/9oACAEBAAEFAlMICYW5aYIF8zTD1E3q8EYx/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/AUhk/8QAFxEAAwEAAAAAAAAAAAAAAAAAAQMQEf/aAAgBAgEBPwEHYqf/xAAcEAACAgIDAAAAAAAAAAAAAAABEQIQACEgMfD/2gAIAQEABj8Ccccjuj51roBcP//EABwQAQADAQADAQAAAAAAAAAAAAEAESExQVFxsf/aAAgBAQABPyFFnlWkV2Ue5TK4KF7+IHK2V3iBk6/JWyI0T//aAAwDAQACAAMAAAAQRwD+/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEREMH/2gAIAQMBAT8Qg40RnTP/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhMf/aAAgBAgEBPxCLGYcMrP/EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQVGBsf/aAAgBAQABPxChJZLG5Rhzto6DUAOS4OYKUWDp98lyAAzj7ESKQKC0ZX24QMAMNQBwDALGyLTRmf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Teapot Single Refraction",
            "title": "Figure 1: Teapot Single Refraction",
            "src": "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg",
            "srcSet": ["/static/17bb31ca70196b0f1287189685540a64/75985/teapot-refraction-single.jpg 150w", "/static/17bb31ca70196b0f1287189685540a64/f93b5/teapot-refraction-single.jpg 300w", "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg 339w"],
            "sizes": "(max-width: 339px) 100vw, 339px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Teapot Single Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "279px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "114.00000000000001%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAXABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBQQG/8QAGAEAAgMAAAAAAAAAAAAAAAAAAAIBAwT/2gAMAwEAAhADEAAAAenLmgal6QRiQU6AZP/EABwQAAICAgMAAAAAAAAAAAAAAAEDAAISIhETI//aAAgBAQABBQLzXV1u5nBi9l7EpqaKwuuAkjGf/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAECEBH/2gAIAQMBAT8By5SZw//EABgRAAMBAQAAAAAAAAAAAAAAAAABEQIQ/9oACAECAQE/AbeZ02in/8QAHhAAAQMFAQEAAAAAAAAAAAAAAQACEQMQEiExQWH/2gAIAQEABj8CFSq7MniluhY+u4FjCAEfVKgaFv/EABwQAQACAgMBAAAAAAAAAAAAAAEAETFBIVFxkf/aAAgBAQABPyHvk9pUBoJdgWFolBR6wK3kcpLt2/Ucl8Y/qXNGY0n/2gAMAwEAAgADAAAAEHf/AAD/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEx/9oACAEDAQE/EADtkQCRf//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxBSstCwr//EAB4QAQACAgMAAwAAAAAAAAAAAAEAESExQWFxgaGx/9oACAEBAAE/EAFo6NHw59YGIOtLfruGghiwgQ2Jd1YtfBBjQ1GKAtWakaxTbKfkORUpFoaeJwspqfbtOpYqf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Sphere Single Refraction",
            "title": "Figure 1: Sphere Single Refraction",
            "src": "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg",
            "srcSet": ["/static/419ba287399db2b43180860d35920c75/75985/sphere-refraction-single.jpg 150w", "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg 279w"],
            "sizes": "(max-width: 279px) 100vw, 279px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Sphere Single Refraction`}</figcaption>{`
  `}</figure>
    <h1>{`Double Refraction`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "345px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "98%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAwb/xAAYAQADAQEAAAAAAAAAAAAAAAABAgMABP/aAAwDAQACEAMQAAABmpm2s3mFgDYyzlvyF0//xAAaEAADAAMBAAAAAAAAAAAAAAABAgMAERMi/9oACAEBAAEFAoOVrVK2AySDo8fDsNvrkSSABn//xAAWEQADAAAAAAAAAAAAAAAAAAABIDH/2gAIAQMBAT8BNT//xAAXEQADAQAAAAAAAAAAAAAAAAABAxAh/9oACAECAQE/AQci5//EAB8QAQACAQMFAAAAAAAAAAAAAAEAAhEQInEDITFBQv/aAAgBAQAGPwLYZZZt8etAuteJ36l8czaGAngmFXT/xAAZEAEAAwEBAAAAAAAAAAAAAAABABEhMVH/2gAIAQEAAT8hLovgTOuHEWaHj6hqzTbh4KwLrrCPAZkWBj1uVp//2gAMAwEAAgADAAAAEHQwPv/EABgRAQEBAQEAAAAAAAAAAAAAAAEAESFR/9oACAEDAQE/EDnVjHTX1m//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QBhuM/8QAHRABAAICAwEBAAAAAAAAAAAAAQARIUExUWGRcf/aAAgBAQABPxABYKfZclY4ADi7Df2XtncPjGona+vYFEUrQdyxxCK4sv1lANw5H5OAuw8KeHDXM//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: Teapot Double Refraction",
            "title": "Figure 2: Teapot Double Refraction",
            "src": "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg",
            "srcSet": ["/static/4ffc1ebdaa010f31d60a944bf5497129/75985/teapot-refraction-double.jpg 150w", "/static/4ffc1ebdaa010f31d60a944bf5497129/f93b5/teapot-refraction-double.jpg 300w", "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg 345w"],
            "sizes": "(max-width: 345px) 100vw, 345px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: Teapot Double Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "307px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "109.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAWABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAACA//aAAwDAQACEAMQAAABvlulXC1xnyMd6Co//8QAGhAAAgMBAQAAAAAAAAAAAAAAAgMAARITEf/aAAgBAQABBQKmqSph9mUoyiy8AkDwWwAAk5lDqZn/xAAXEQADAQAAAAAAAAAAAAAAAAABAhAR/9oACAEDAQE/AY4wz//EABcRAAMBAAAAAAAAAAAAAAAAAAECECH/2gAIAQIBAT8BinJ//8QAHRAAAgICAwEAAAAAAAAAAAAAAAECERIhECJhE//aAAgBAQAGPwJSh2ky5aOsbRJVdn0yx8ElNemmb4//xAAdEAEAAgICAwAAAAAAAAAAAAABABExQVFhIXGx/9oACAEBAAE/ISU7OpTZPGIQqWVZFMGzmupVO58j+QO7ftEN4YyuGf/aAAwDAQACAAMAAAAQV++8/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARMf/aAAgBAwEBPxDA7ZAATf/EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QVe3JHTbf/8QAIRABAAICAQMFAAAAAAAAAAAAAQARIUExUWFxgZGxwdH/2gAIAQEAAT8Qpo6rVK3bo+ZQsVAMPd9wgUVDEo0E6hsjbV+OZR7spjQ2vfiPIqyDlZfz0jLxiS6BRwXKXkn/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: Sphere Double Refraction",
            "title": "Figure 2: Sphere Double Refraction",
            "src": "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg",
            "srcSet": ["/static/f07226121a2bcdbe437c6f4977f6b351/75985/sphere-refraction-double.jpg 150w", "/static/f07226121a2bcdbe437c6f4977f6b351/f93b5/sphere-refraction-double.jpg 300w", "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg 307w"],
            "sizes": "(max-width: 307px) 100vw, 307px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: Sphere Double Refraction`}</figcaption>{`
  `}</figure>
    <p>{`More pictures:`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "202px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "221.99999999999997%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAsABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAABAAFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAeQ8Ppzr1ofNwVppQITLWijAt2N//8QAHhAAAwACAgMBAAAAAAAAAAAAAQIDABEEMhITISP/2gAIAQEAAQUC5VFbChwYn0zsUk2tz7cUoG/LE7QkKH0DFHiRHc2ZmPJRWyGkSiqzf//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BX//EABYRAQEBAAAAAAAAAAAAAAAAABAhAf/aAAgBAgEBPwHax//EACEQAAEEAQMFAAAAAAAAAAAAAAEAAhEhAxAiMTNBYYGR/9oACAEBAAY/AgxvAVDS0ccrbxo4ZI9qms+6GbrsuoFZAPlB+F0kcrcgYtbQFJaF/8QAHRAAAgMBAQADAAAAAAAAAAAAAAERITFRYRBBgf/aAAgBAQABPyGPq+19Irba3wkJXwUlw4mJoZ3g0MRfF8DTWwvPhWD0tZy/XSfJHuRKq74dgSgmGGKIGE3r6SZ2f//aAAwDAQACAAMAAAAQ9CRCg9//xAAXEQADAQAAAAAAAAAAAAAAAAAAESAx/9oACAEDAQE/EMhjP//EABgRAAIDAAAAAAAAAAAAAAAAAAERABAh/9oACAECAQE/ECbKEcELa//EAB4QAQADAAMAAwEAAAAAAAAAAAEAESExQVFxgaGx/9oACAEBAAE/ELQzX6pYvOss+0SHe4G8igpDeuYpNMG70HXN/UdukDUTYVZuw6wIo2H3GT1wCG+VUO+RGLUfEV5rucyQVzI+SWAVlDePJQ4BgT+kGOjXSmj2VA2KcWQ0wPZf6l5hNad/Z//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 3: Lucid Double Refraction",
            "title": "Figure 3: Lucid Double Refraction",
            "src": "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg",
            "srcSet": ["/static/26b64e5652bd4709e3e96d0d97c6d8c8/75985/lucid-refraction-double.jpg 150w", "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg 202w"],
            "sizes": "(max-width: 202px) 100vw, 202px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 3: Lucid Double Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "306px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "115.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAXABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIEBQED/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgMA/9oADAMBAAIQAxAAAAGFeFjPPbjHwqEK9FR//8QAGxAAAgMAAwAAAAAAAAAAAAAAAQIAAxEEEhP/2gAIAQEAAQUCrtcUWa4ijVfa4OMpDV+Jwlu9k//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABcRAAMBAAAAAAAAAAAAAAAAAAEQEQL/2gAIAQIBAT8BqwTF/8QAHhABAAICAQUAAAAAAAAAAAAAAQARAjEQIjJhkZL/2gAIAQEABj8CTFDzDJtdXwQD5Z17mKaG5fqdzP/EABwQAQACAgMBAAAAAAAAAAAAAAEAESExUWFxgf/aAAgBAQABPyEb2O25ZjeLVyqiZGFoO4BBdvJDKHnTR8hM7wkWitX6l/Xjc//aAAwDAQACAAMAAAAQcBj9/8QAGBEBAQEBAQAAAAAAAAAAAAAAEQEAECH/2gAIAQMBAT8QD3lKUxN//8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAgEBPxBTZI7bb//EACAQAQACAgIBBQAAAAAAAAAAAAERIQBRMUFxYaHB0eH/2gAIAQEAAT8QpQqaGvQfOVNwt/A+MnyqbJweCNsQ7O38xAAufklMdc+2T7crEOho+8AJNo27vCLxJKHoWO8aUhVMqz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Elephant Double Refraction",
            "title": "Figure 4: Elephant Double Refraction",
            "src": "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg",
            "srcSet": ["/static/8e2a9334a738015c1b8954394ac71f3d/75985/elephant-refraction-double.jpg 150w", "/static/8e2a9334a738015c1b8954394ac71f3d/f93b5/elephant-refraction-double.jpg 300w", "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg 306w"],
            "sizes": "(max-width: 306px) 100vw, 306px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Elephant Double Refraction`}</figcaption>{`
  `}</figure>
    <h1>{`References`}</h1>
    <p>{`[2005]`}{` C Wyman. An approximate image-space approach for interactive refraction. pages 1050–1053. ACM, 2005.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      